export interface EditBlockedSlotConfirmationFormModel {
    editMode: EditBlockedSlotMode;
}

export enum EditBlockedSlotMode {
    thisEvent = 'this-event',
    thisAndFollowing = 'this-and-following'
}
  